export const blue = "#007AFF";
export const lightblue = "#D7EBFF";
export const red = "#D0021B";
export const lightred = "#FFDFDF";
export const faintBlue = "rgba(8,157,244,0.1)";
export const lightGray = "#e5e5e5";

// TODO: Clarify the meaning of this
export const white = "#ffffff";
export const lightgrey = "#E1E1EB";
export const grey = "#7A7A82";
export const grey1 = "#EDEDF7";
export const black = "#000000";
